import { z } from 'zod';
import { DateTime } from 'luxon';
import { DateTimeSchema, ObjectIdSchema } from '../common.js';

export const ConcurrencyLockStatus = z.enum(['pending', 'completed', 'failed']);
export type ConcurrencyLockStatus = z.infer<typeof ConcurrencyLockStatus>;

export const IConcurrencyLockBase = z.object({
  _id: ObjectIdSchema,
  type: z.enum(['event', 'auth']),
  key: z.string(),
  status: ConcurrencyLockStatus.default('pending'),
  completedDate: DateTimeSchema.nullable(),
  expirationDate: DateTimeSchema.default(() => DateTime.now().plus({ days: 7 })),
  data: z.looseObject({}).nullish(),
  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type IConcurrencyLockBase = z.infer<typeof IConcurrencyLockBase>;

// Event locks track cron/webhook event processing. Status transitions to completed/failed and the document is kept for audit.
export const IEventLock = IConcurrencyLockBase.extend({
  type: z.literal('event'),
});
export type IEventLock = z.infer<typeof IEventLock>;

// Auth locks serialize authentication per integration. Deleted immediately on release.
export const IAuthLock = IConcurrencyLockBase.extend({
  type: z.literal('auth'),
});
export type IAuthLock = z.infer<typeof IAuthLock>;

export const IConcurrencyLock = z.discriminatedUnion('type', [IEventLock, IAuthLock]);
export type IConcurrencyLock = z.infer<typeof IConcurrencyLock>;
